import { DateHelper } from "../../../../Common/DateHelper";
import Helper from "../../../../Common/Helper";
import { ODataSelect } from "../../../../Providers.Api/ODataQuery";

export interface IUser
{
    email: string,
}

export class CateringOrder extends ODataSelect
{
    public Node_Id = 0;
    public ID = 0;
    public Booking_Name = '';
    public CreatedBy = '';
    public Space_Name = '';
    public Space_Id = '';
    public Booking_Id = '';
    public Catering_Service_Time = DateHelper.null();
    public Catering_Clearing_Time = DateHelper.null();
    public Booking_Start = DateHelper.null();
    public Booking_End = DateHelper.null();
    public Order_Id = '';
    public Menu_Items: IMenuItem[] = [];
    public OwnedBy = '';
    public OwnedById = '';
    public Catering_Order_Status = '';
    public Cost_Code_Allocation: ICostCodeAllocation[] = [];

    public init(response: any, nodeId: number): CateringOrder
    {
        super.init(response, nodeId);
        this.Catering_Service_Time = DateHelper.fromIsoByNode(response.Catering_Service_Time, nodeId);
        this.Catering_Clearing_Time = DateHelper.fromIsoByNode(response.Catering_Clearing_Time, nodeId);
        this.Booking_Start = DateHelper.fromIsoByNode(response.Booking_Start, nodeId);
        this.Booking_End = DateHelper.fromIsoByNode(response.Booking_End, nodeId);
        this.Menu_Items = Helper.parseJsonArray<IMenuItem>(response.Menu_Items);
        this.Cost_Code_Allocation = Helper.parseJsonArray<ICostCodeAllocation>(response.Cost_Code_Allocation);

        return this;
    }
}

export interface IMenuItem
{
    Id: string;
    Menu_Id: string;
    Description?: string;
    QuantityOfItems: number;
}


export interface ICostCodeAllocation
{
    Cost_Code: string;
    Cost_Code_Id: string;
    Allocation: number;
}

export class SystemFilter extends ODataSelect
{
    public CreatedByUserId?= '';
    public EventType_Id = 0;
    public Filter = '';
    public Filter_Id?= '';
    public ModifiedAt = DateHelper.null();
    public CreatedAt = DateHelper.null();
    public ModifiedByUserId?= '';
    public Name = '';
    public Node_Id = 0;
    public OwnedByRoleId = '';
    public OwnedByUserId = '';
    public Status = '';
    public Building_Bypass = false;
    public TenancyId?= '';

    public init(response: any, nodeId: number): SystemFilter
    {

        super.init(response, nodeId);
        this.CreatedAt = DateHelper.fromIsoByNode(response.CreatedAt, nodeId);
        this.ModifiedAt = DateHelper.fromIsoByNode(response.ModifiedAt, nodeId);
        return this;
    }
}